import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = ({ onClose, onSwitch }) => {
  const [form, setForm] = useState({ username: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const login = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/users/token`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(form),
    });

    if (!response.ok) {
      alert("Login failed");
      return;
    }

    const data = await response.json();
    localStorage.setItem("token", data.access_token);

    const res = await fetch(`${process.env.REACT_APP_API_URL}/users/me`, {
      headers: {
        Authorization: `Bearer ${data.access_token}`,
      },
    });

    if (res.ok) {
      const userData = await res.json();
      localStorage.setItem("username", userData.username);
    }

    alert("Login successful");
    onClose();
    window.location.href = "/dashboard";
  };

  return (
    <div className="container max-w-md w-full bg-white rounded-xl shadow p-6 sm:p-8 mx-auto mt-8">
      <h2 className="text-2xl font-bold text-center text-primary mb-6">
        Login to TripsFlare
      </h2>
      <div className="space-y-4">
        <input
          type="text"
          name="username"
          placeholder="Username"
          onChange={handleChange}
          className="form-input"
        />
		<div className="relative">
        <input
          type={showPassword ? "text" : "password"}
          name="password"
          placeholder="Password"
          onChange={handleChange}
          className="form-input pr-10"
        />
          <div
            className="absolute inset-y-0 right-3 flex items-center cursor-pointer"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </div>
        </div>		
        <button
          onClick={login}
          className="btn-full bg-primary text-white p-3 rounded hover:bg-orange-600 transition"
        >
          Login
        </button>
        <p className="text-center text-sm mt-4">
          Don’t have an account?{" "}
          <button onClick={onSwitch} className="text-secondary underline">
            Register
          </button>
        </p>
      </div>
    </div>
  );
};

export default Login;
